import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import CommonDropdown from "../common/common_dropDown";
import uploadIcon from "../../assets/svg/upload_file.svg";
import closeAttachment from "../../assets/svg/close-red.svg";
import SignatureCanvas from "react-signature-canvas";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const LocationPicker = ({ setPosition }) => {
  useMapEvents({
    click(e) {
      setPosition(e.latlng);
    },
  });
  return null;
};

const MilestoneUpdateModal = ({ show, onHide, onSubmit, skippedUpdate, milestoneDetails, errorMsgMilestone = {} }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const fileInputRef = useRef(null);

  const sigRef = useRef(null);
  const [imageURL, setImageURL] = useState(null);

  const clear = () => sigRef.current.clear();
  const save = () => {
    setImageURL(sigRef.current.getTrimmedCanvas().toDataURL("image/png"));
  };

  const [isLoading, setIsLoading] = useState(false);
  const [clickButton, setClickButton] = useState("");
  // Form states
  const [selectedTrip, setSelectedTrip] = useState("");
  const [selectedStop, setSelectedStop] = useState("");
  const [statusList, setStatusList] = useState([]);
  const [statusIndex, setStatusIndex] = useState(-1);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [status, setStatus] = useState("");
  const [comments, setComments] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [attachmentPreview, setAttachmentPreview] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [mapCenter, setMapCenter] = useState([20.5937, 78.9629]);

  useEffect(() => {
    if (!show) {
      clearModel();
    }
  }, [show]);
  /*   const [errorMsg, setErrorMsg] = useState({
    trip_id: "",
    stop_id: "",
    milestone_id: "",
    title: "",
    status: "",
    comments: "",
    signature: "",
    attachments: "",
    latitude: "",
    longitude: "",
  }); */

  useEffect(() => {
    setStatusIndex(-1);
    if (skippedUpdate === true) {
      setSelectedTrip(milestoneDetails?.tripCode ?? "");
      setSelectedStop(milestoneDetails?.stopCode ?? "");
      setStatusList(milestoneDetails?.Milestone_status || []);
    } else {
      setSelectedTrip(milestoneDetails?.trip?.trip_id ?? "");
      setSelectedStop(milestoneDetails?.stopCode ?? "");
      setStatusList(milestoneDetails?.status || []);
    }
  }, [milestoneDetails]);
  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    const newAttachments = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setAttachments([...attachments, ...newAttachments]);
    if (newAttachments.length > 0) {
      setAttachmentPreview(newAttachments[0].preview);
    }
  };

  const handleDragDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    const newAttachments = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setAttachments([...attachments, ...newAttachments]);
    if (newAttachments.length > 0) {
      setAttachmentPreview(newAttachments[0].preview);
    }
  };

  const removeAttachment = (index) => {
    const newAttachments = attachments.filter((_, idx) => idx !== index);
    setAttachments(newAttachments);
    if (newAttachments.length === 0) {
      setAttachmentPreview(null);
    } else {
      setAttachmentPreview(newAttachments[0].preview);
    }
  };

  const handleSubmit = async (buttonType) => {
    // Convert attachments to base64
    const fileToBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(file);
      });

    let attachmentsBase64 = [];
    try {
      attachmentsBase64 = await Promise.all(attachments.map((att) => fileToBase64(att.file)));
    } catch (err) {
      console.error("Error converting attachments to base64:", err);
    }
    const selectedStatus = statusList[statusIndex] || {};
    const payload = {
      trip_id: milestoneDetails?.trip?.id,
      stop_id: milestoneDetails?.stopId,
      milestone_id: skippedUpdate === true ? milestoneDetails.milestone_id : selectedStatus?.milestone_id,
      box_id: selectedStatus?.box_id,
      title: selectedStatus?.title,
      status: buttonType === "skip" ? "skipped" : selectedStatus?.status,
      comments: comments,
      signature: sigRef?.current?.toDataURL("image/png") ?? "",
      attachments: attachmentsBase64,
      latitude: latitude,
      longitude: longitude,
    };

    try {
      setIsLoading(true);
      onSubmit(payload);
    } catch (err) {
      /* const errorMessages = err.response?.data?.errors || {};
      setErrorMsg((prev) => ({ ...prev, ...errorMessages })); */
    } finally {
      setIsLoading(false);
    }
  };

  const clearModel = () => {
    // Reset form on close
    setSelectedTrip("");
    setSelectedStop("");
    setLatitude("");
    setLongitude("");
    setStatus("");
    setComments("");
    setAttachments([]);
    setAttachmentPreview(null);
    /* setErrorMsg({
      trip_id: "",
      stop_id: "",
      milestone_id: "",
      title: "",
      status: "",
      comments: "",
      signature: "",
      attachments: "",
      latitude: "",
      longitude: "",
    }); */
  };
  const handleClose = () => {
    clearModel();
    onHide();
  };
  const [showMap, setShowMap] = useState(false);
  const [mapPosition, setMapPosition] = useState(null);
  const [activeField, setActiveField] = useState(null);
  const handleMapConfirm = () => {
    if (mapPosition) {
      const lat = mapPosition.lat.toFixed(6);
      const lng = mapPosition.lng.toFixed(6);

      setLatitude(lat);
      setLongitude(lng);

      setShowMap(false);
      setMapPosition(null);
    }
  };

  const handleSearch = async () => {
    if (!searchQuery.trim()) return;

    setIsSearching(true);
    try {
      const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}&limit=5`);
      const data = await response.json();
      setSearchResults(data);
    } catch (error) {
      console.error("Error searching location:", error);
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  };
  const handleSelectSearchResult = (result) => {
    const lat = parseFloat(result.lat);
    const lng = parseFloat(result.lon);
    setMapCenter([lat, lng]);
    setMapPosition({ lat, lng });
    setSearchResults([]);
    setSearchQuery(result.display_name);
  };
  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static" size="lg" centered>
        <Modal.Header closeButton className="border-bottom">
          <Modal.Title className="fw-700 fs-18">Update milestone</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "16px" }}>
          <div className="row">
            <div className={`${statusList.length > 0 && statusIndex > -1 && statusList[statusIndex].signature === true ? "col-md-7" : "col-md-12"}`}>
              {/* Trip ID and Stop ID Row */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="d-flex flex-column align-items-start">
                    <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Trip ID</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      value={selectedTrip || ""}
                      readOnly
                      style={{
                        backgroundColor: "#F5F5F5",
                        cursor: "not-allowed",
                      }}
                    />
                    {errorMsgMilestone.trip_id && <small className="text-danger mt-1">{errorMsgMilestone.trip_id}</small>}
                  </div>
                </div>

                {statusList.length > 0 && statusIndex > -1 && statusList[statusIndex].stoplevel === true && (
                  <div className="col-md-6 mb-3">
                    <div className="d-flex flex-column align-items-start">
                      <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Stop ID</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        value={selectedStop || ""}
                        readOnly
                        style={{
                          backgroundColor: "#F5F5F5",
                          cursor: "not-allowed",
                        }}
                      />
                      {errorMsgMilestone.stop_id && <small className="text-danger mt-1">{errorMsgMilestone.stop_id}</small>}
                    </div>
                  </div>
                )}
              </div>

              {/* Latitude and Longitude Row with Pin in Map Button */}
              <div className="row">
                <div className="col-md-4 mb-3">
                  <div className="d-flex flex-column align-items-start">
                    <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Latitude</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      value={latitude}
                      readOnly
                      style={{
                        backgroundColor: "#F5F5F5",
                        cursor: "not-allowed",
                      }}
                    />
                    {errorMsgMilestone.latitude && <small className="text-danger mt-1">{errorMsgMilestone.latitude}</small>}
                  </div>
                </div>

                <div className="col-md-4 mb-3">
                  <div className="d-flex flex-column align-items-start">
                    <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Longitude</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      value={longitude}
                      readOnly
                      style={{
                        backgroundColor: "#F5F5F5",
                        cursor: "not-allowed",
                      }}
                    />
                    {errorMsgMilestone.longitude && <small className="text-danger mt-1">{errorMsgMilestone.longitude}</small>}
                  </div>
                </div>

                <div className="col-md-4 mb-3 d-flex align-items-end">
                  <Button
                    variant="primary"
                    onClick={() => {
                      setMapPosition(null);
                      setShowMap(true);
                    }}
                    className="w-100"
                    style={{ height: "38px" }}
                  >
                    Pin in map
                  </Button>
                </div>
              </div>

              {/* Status Radio Buttons */}
              <div className="mb-3">
                <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Status</label>
                <div className="d-flex gap-3">
                  {statusList.map((option, index) => (
                    <div
                      key={option.index}
                      className="cursor-pointer form-check"
                      onClick={() => {
                        setStatusIndex(index);
                        setStatus(option.status);
                      }}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="status"
                        id={`status-${option.index}`}
                        value={option.status}
                        checked={status === option.status}
                        onChange={(e) => {
                          setStatus(e.target.value);
                        }}
                      />
                      <div className="form-check-label fs-13 fw-500" htmlFor={`status-${option.index}`}>
                        {option.status}
                      </div>
                    </div>
                  ))}
                </div>
                {errorMsgMilestone.status && <small className="text-danger mt-1">{errorMsgMilestone.status}</small>}
              </div>

              {/* Comments */}
              {statusList.length > 0 && statusIndex > -1 && statusList[statusIndex].comment === true && (
                <div className="mb-3">
                  <div className="d-flex flex-column align-items-start">
                    <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Comments</label>
                    <textarea className="form-control" placeholder="Enter here..." rows="3" value={comments} onChange={(e) => setComments(e.target.value)} />
                    {errorMsgMilestone.comments && <small className="text-danger mt-1">{errorMsgMilestone.comments}</small>}
                  </div>
                </div>
              )}

              {/* Attachments */}
              {statusList.length > 0 && statusIndex > -1 && statusList[statusIndex].attachment === true && (
                <div>
                  <div className="d-flex flex-column align-items-start">
                    <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Attachments</label>
                    {errorMsgMilestone.attachments && <small className="text-danger mt-1">{errorMsgMilestone.attachments}</small>}
                    <div
                      className="rounded-3 p-4 d-flex align-items-center justify-content-center w-100"
                      style={{
                        height: 150,
                        cursor: "pointer",
                        border: "2px dashed #3469E7",
                        backgroundColor: "#F8FAFF",
                      }}
                      onClick={() => fileInputRef.current?.click()}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={handleDragDrop}
                    >
                      {attachmentPreview ? (
                        <img
                          src={attachmentPreview}
                          alt="preview"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                          }}
                        />
                      ) : (
                        <div className="text-center">
                          <img src={uploadIcon} alt="upload" className="mb-2" style={{ width: 40, height: 40 }} />
                          <p className="fs-13 fw-400 text-21272C mb-1">
                            Drag and drop or <strong className="text-3469E7">Select a file</strong>
                          </p>
                          <p className="text-gray fs-11 fw-400">You can add any type of files here.</p>
                        </div>
                      )}
                    </div>

                    {attachments.length > 0 && (
                      <div className="d-flex flex-wrap gap-2 mt-3">
                        {attachments.map((att, idx) => (
                          <div key={idx} className="position-relative" style={{ width: 80, height: 80 }}>
                            <img
                              src={att.preview}
                              alt={`thumb-${idx}`}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: 8,
                                cursor: "pointer",
                                background: "#F5F5F5",
                                border: "none",
                                padding: "4px",
                              }}
                              onClick={() => setAttachmentPreview(att.preview)}
                            />
                            <button
                              className="btn btn-sm position-absolute"
                              style={{
                                top: -8,
                                right: -8,
                                padding: "2px 6px",
                                fontSize: "10px",
                                borderRadius: "100px",
                                border: "1px solid #E5E5E5",
                                width: "21px",
                                height: "21px",
                                background: "#FFFFFF",
                              }}
                              onClick={() => removeAttachment(idx)}
                            >
                              <img src={closeAttachment} alt="close" />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}

                    <input ref={fileInputRef} type="file" multiple onChange={handleFileUpload} style={{ display: "none" }} />
                  </div>
                </div>
              )}
            </div>
            {statusList.length > 0 && statusIndex > -1 && statusList[statusIndex].signature === true && (
              <div className="col-md-5">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <label className="form-label fs-13 fw-600 text-start vehicle-label mb-0">Signature</label>

                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={clear}
                    className="rounded-pill px-3"
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      borderColor: "#E74C3C",
                      color: "#E74C3C",
                    }}
                  >
                    Clear
                  </Button>
                </div>
                {errorMsgMilestone.signature && <div className="text-danger fs-12 mb-2">{errorMsgMilestone.signature}</div>}
                <div
                  style={{
                    borderRadius: "13px",
                    overflow: "hidden",
                    backgroundColor: "#f6f6f6",
                  }}
                >
                  <SignatureCanvas
                    ref={sigRef}
                    penColor="black"
                    canvasProps={{
                      height: 388,
                      className: "sigCanvas w-100",
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top">
          <Button variant="outline-secondary" onClick={handleClose} className="rounded-pill px-4" style={{ borderColor: "#D4DDE7", color: "#212129" }}>
            Cancel
          </Button>
          {statusList.length > 0 && statusIndex > -1 && statusList[statusIndex].skip === true && (
            <Button
              variant="outline-primary"
              onClick={() => {
                // Handle skip logic
                setClickButton("skip");
                handleSubmit("skip");
              }}
              className="rounded-pill px-4"
              style={{ borderColor: "#3469E7", color: "#3469E7" }}
            >
              {isLoading && clickButton === "skip" ? <Spinner animation="border" size="sm" /> : "Skip"}
            </Button>
          )}
          <Button
            variant="primary"
            onClick={() => {
              setClickButton("save");
              handleSubmit("save");
            }}
            className="dark-purple-btn rounded-pill px-4 d-flex justify-content-center align-items-center"
            disabled={isLoading}
          >
            {isLoading && clickButton === "save" ? <Spinner animation="border" size="sm" /> : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showMap} onHide={() => setShowMap(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Location</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <div className="d-flex gap-2">
              <div style={{ position: "relative", flex: 1 }}>
                <Form.Control
                  type="text"
                  placeholder="Search for a location (e.g., Mumbai, India or specific address)"
                  className="fs-13"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearch();
                    }
                  }}
                />

                {searchResults.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      backgroundColor: "white",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      maxHeight: "200px",
                      overflowY: "auto",
                      zIndex: 1000,
                      marginTop: "4px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    {searchResults.map((result, index) => (
                      <div
                        key={index}
                        className="p-2 cursor-pointer"
                        style={{
                          borderBottom: index < searchResults.length - 1 ? "1px solid #f1f3f5" : "none",
                          cursor: "pointer",
                        }}
                        onClick={() => handleSelectSearchResult(result)}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f8f9fa")}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}
                      >
                        <div className="fs-13 fw-500">{result.display_name}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <Button variant="primary" onClick={handleSearch} disabled={isSearching || !searchQuery.trim()} style={{ backgroundColor: "#3469E7", borderColor: "#3469E7" }}>
                {isSearching ? "Searching..." : "Search"}
              </Button>
            </div>
          </div>
          <div style={{ height: "350px", width: "100%" }}>
            <MapContainer center={[20.5937, 78.9629]} zoom={5} style={{ height: "100%", width: "100%" }}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' />
              <LocationPicker setPosition={setMapPosition} />
              {mapPosition && <Marker position={mapPosition} />}
            </MapContainer>
          </div>
          <div className="mt-2 text-muted fs-13">{mapPosition ? `Selected: ${mapPosition.lat.toFixed(6)}, ${mapPosition.lng.toFixed(6)}` : "Click on the map to select a location"}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowMap(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleMapConfirm} disabled={!mapPosition} style={{ backgroundColor: "#3469E7", borderColor: "#3469E7" }}>
            Select Location
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MilestoneUpdateModal;
